// src/api/Expenses/expenseDocumentsApi.js
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const getAuthHeaders = () => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("No token");
  return {
    Authorization: `Bearer ${token}`,
  };
};

// 📄 Obtener documentos
export const getExpenseDocuments = async () => {
  const res = await axios.get(`${API_URL}/api/expense-documents`, {
    headers: getAuthHeaders(),
  });
  return res.data;
};

// ➕ Crear documento
export const createExpenseDocument = async () => {
  const res = await axios.post(
    `${API_URL}/api/expense-documents`,
    {},
    {
      headers: getAuthHeaders(),
    },
  );
  return res.data;
};

// 🗑️ Eliminar documento
export const deleteExpenseDocument = async (id) => {
  const res = await axios.delete(`${API_URL}/api/expense-documents/${id}`, {
    headers: getAuthHeaders(),
  });
  return res.data;
};
